"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ModalContext_1 = require("./ModalContext");
function isModalContainer(el) {
    return el.id === ModalContext_1.MODAL_ROOT_ELEMENT_ID;
}
function withinModalsContainer(target) {
    let currentEl = target;
    const body = document.body;
    while (currentEl && currentEl !== body) {
        if (isModalContainer(currentEl)) {
            return true;
        }
        currentEl = currentEl.parentElement;
    }
    return false;
}
exports.default = withinModalsContainer;
//# sourceMappingURL=withinModalsContainer.js.map